// @flow
import React, { Component } from "react";

type PropsType = {
  translate: string => void
};

type StateType = {};

class HeroUnit extends Component<PropsType, StateType> {
  render() {
    const { translate } = this.props;
    return (
      <header className="header text-center text-white public-pages-header-area">
        <div className="container">
          <div className="row align-items-center h-100">
            <div className="col-md-10 mx-auto">
              <h1>{translate("ContactPageLocale.header.title")}</h1>
              <p className="lead-3">
              {translate("ContactPageLocale.header.content")}
              </p>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default HeroUnit;



// WEBPACK FOOTER //
// ./src/Components/PublicPages/Components/ContactPage/HeroUnit.js